// redux/Slices/chatSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  conversations: [],
  totalUnread: 0,
  activeChatUserId: null,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setConversations: (state, action) => {
      state.conversations = action.payload;
    },
    updateConversation: (state, action) => {
      const updated = action.payload;
      console.log("[Redux] Updating/Adding conversation:", updated); // ← is this firing?
    
      const idx = state.conversations.findIndex((c) => c.id === updated.id);
      if (idx !== -1) {
        state.conversations[idx] = updated;
      } else {
        console.log("[Redux] Adding NEW conversation to state");
        state.conversations.push(updated);
      }
    },
    recalculateTotalUnread: (state) => {
      const myId = localStorage.getItem("hcc_id");
      state.totalUnread = state.conversations.reduce((sum, convo) => {
        if (convo.user1_id === myId) return sum + (convo.user1_unread || 0);
        if (convo.user2_id === myId) return sum + (convo.user2_unread || 0);
        return sum;
      }, 0);
    },
    setActiveChatUserId: (state, action) => {
      state.activeChatUserId = action.payload;
    },
  },
});

export const {
  setConversations,
  updateConversation,
  recalculateTotalUnread,
  setActiveChatUserId,
} = chatSlice.actions;

export default chatSlice.reducer;
